import { Modal } from "react-bootstrap";
import { IoArrowRedoOutline } from "react-icons/io5";
import { GrLocation } from "react-icons/gr";
import { MdMailOutline, MdOutlinePhone } from "react-icons/md";

const PrivacyPolicyModel = ({ openPrivacyPolicy, setOpenPrivacyPolicy }) => {

  return (
    <Modal show={openPrivacyPolicy} size="xl" onHide={() => setOpenPrivacyPolicy(false)} centered>
      <Modal.Header closeButton>
        <div className="model-title-cont">
          <h2 className='Model-title'>Privacy Policy</h2>
          <span>Last Updated: 12-January-2026</span>
        </div>
      </Modal.Header>

      <Modal.Body>
        <div className='Model-content'>
          <h4 className='Model-sub-title'>Introduction</h4>
          <p>This Privacy Policy describes how BWE Financial Services ("we," "us," or "our") collects, uses, discloses, and protects information when you use our loan origination system and related services (collectively, the "Services"). We are committed to protecting your privacy and maintaining the security of your data in compliance with all applicable laws, including the Reserve Bank of India (RBI) regulations and the Information Technology Act, 2000.</p>
          <p>These Terms constitute a legally binding agreement between you and BWE Financial Services.</p>
          <h4 className='Model-sub-title'>Information We Collect</h4>
          <span className="Model-sec-sub-title">Information You Provide</span>
          <ul className="termandCondi_list">
            <li><IoArrowRedoOutline /> Contact information (name, email address, phone number, business address)</li>
            <li><IoArrowRedoOutline /> Business information (company name, role, institution details)</li>
            <li><IoArrowRedoOutline /> Account credentials and authentication information</li>
            <li><IoArrowRedoOutline /> Communication preferences and feedback</li>
          </ul>

          <span className="Model-sec-sub-title">Information Collected Through the Services</span>
          <ul className="termandCondi_list">
            <li><IoArrowRedoOutline /> Borrower and loan application data you input into our system</li>
            <li><IoArrowRedoOutline /> User activity logs and system usage data</li>
            <li><IoArrowRedoOutline /> Device information and IP addresses</li>
            <li><IoArrowRedoOutline /> Geolocation data (when using our mobile applications with your consent)</li>
          </ul>

          <span className="Model-sec-sub-title">Information from Third Parties</span>
          <ul className="termandCondi_list">
            <li><IoArrowRedoOutline /> Data received through integrations with KYC providers, banks, and other third-party services you authorize</li>
            <li><IoArrowRedoOutline /> Bank statement data you upload for analysis</li>
          </ul>
          <h4 className='Model-sub-title'>How We Use Your Information</h4>
          <p>We use the information we collect to:</p>
          <ul className="termandCondi_list">
            <li><IoArrowRedoOutline /> Provide, maintain, and improve our Services</li>
            <li><IoArrowRedoOutline /> Process transactions and manage your account</li>
            <li><IoArrowRedoOutline /> Communicate with you about our Services, including updates and support</li>
            <li><IoArrowRedoOutline /> Analyze usage patterns to enhance user experience</li>
            <li><IoArrowRedoOutline /> Ensure security and prevent fraud</li>
            <li><IoArrowRedoOutline /> Comply with legal obligations and regulatory requirements</li>
            <li><IoArrowRedoOutline /> Respond to your inquiries and provide customer support</li>
          </ul>
          <h4 className='Model-sub-title'>Data Storage and Security</h4>
          <p>We implement industry-standard security measures to protect your data, including:</p>
          <ul className="termandCondi_list">
            <li><IoArrowRedoOutline /> Encryption of data in transit and at rest</li>
            <li><IoArrowRedoOutline /> Regular security audits and vulnerability assessments</li>
            <li><IoArrowRedoOutline /> Access controls and authentication mechanisms</li>
            <li><IoArrowRedoOutline /> Secure data centers with physical and digital safeguards</li>
            <li><IoArrowRedoOutline /> Compliance with RBI guidelines on data security</li>
          </ul>
          <p><b>Local Data Storage:</b> We prioritize keeping your data within national borders. Our AI/LLM capabilities use local deployment to ensure sensitive financial information does not leave your infrastructure or cross international boundaries.</p>
          <h4 className='Model-sub-title'>Data Sharing and Disclosure</h4>
          <p>We do not sell your personal information. We may share information only in the following circumstances:</p>
          <ul className="termandCondi_list">
            <li><IoArrowRedoOutline /> <b>With Your Consent:</b> When you authorize integrations with third-party services</li>
            <li><IoArrowRedoOutline /> <b>Service Providers:</b> With trusted vendors who assist in providing our Services, bound by confidentiality agreements</li>
            <li><IoArrowRedoOutline /> <b>Legal Requirements:</b> When required by law, regulation, legal process, or governmental request</li>
            <li><IoArrowRedoOutline /> <b>Business Transfers:</b> In connection with a merger, acquisition, or sale of assets</li>
            <li><IoArrowRedoOutline /> <b>Protection of Rights:</b> To protect our rights, property, or safety, or that of our users or the public</li>
          </ul>
          <h4 className='Model-sub-title'>Your Rights and Choices</h4>
          <p>You have the right to:</p>
          <ul className="termandCondi_list">
            <li><IoArrowRedoOutline /> Access the personal information we hold about you</li>
            <li><IoArrowRedoOutline /> Request correction of inaccurate information</li>
            <li><IoArrowRedoOutline /> Request deletion of your information (subject to legal retention requirements)</li>
            <li><IoArrowRedoOutline /> Opt-out of marketing communications</li>
            <li><IoArrowRedoOutline /> Withdraw consent for data processing where applicable</li>
            <li><IoArrowRedoOutline /> Request data portability</li>
          </ul>
          <p>To exercise these rights, please contact us at <a href="mailto:contact@bwefinserv.com" target="_blank" rel="noreferrer">contact@bwefinserv.com</a>, with the subject "Privacy Policy"</p>
          <h4 className='Model-sub-title'>Data Retention</h4>
          <p>We retain your information for as long as necessary to:</p>
          <ul className="termandCondi_list">
            <li><IoArrowRedoOutline /> Provide our Services to you</li>
            <li><IoArrowRedoOutline /> Comply with legal obligations, including RBI record-keeping requirements</li>
            <li><IoArrowRedoOutline /> Resolve disputes and enforce our agreements</li>
            <li><IoArrowRedoOutline /> Support business operations and auditing purposes</li>
          </ul>
          <h4 className='Model-sub-title'>Cookies and Tracking Technologies</h4>
          <p>We use cookies and similar technologies to enhance your experience, analyze usage, and improve our Services. You can control cookie preferences through your browser settings.</p>
          <h4 className='Model-sub-title'>Third-Party Links and Services</h4>
          <p>Our Services may contain links to third-party websites or integrate with third-party services. We are not responsible for the privacy practices of these third parties. We encourage you to review their privacy policies.</p>
          <h4 className='Model-sub-title'>Children's Privacy</h4>
          <p>Our Services are not intended for individuals under the age of 18. We do not knowingly collect personal information from children.</p>
          <h4 className='Model-sub-title'>International Data Transfers</h4>
          <p>While we prioritize local data storage, if data must be transferred internationally, we ensure appropriate safeguards are in place to protect your information in accordance with applicable laws.</p>
          <h4 className='Model-sub-title'>Changes to This Privacy Policy</h4>
          <p>We may update this Privacy Policy from time to time. We will notify you of material changes by posting the updated policy on our website and updating the "Last Updated" date. Your continued use of our Services after changes constitutes acceptance of the updated policy.</p>
          <h4 className='Model-sub-title'>Contact Us</h4>
          <span className="Model-sec-sub-title">If you have questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us at:</span>
          <div className="model-cont-list">
            <h3>BWE Financial Services</h3>
            <ul>
              <li><GrLocation /> 14 A, 4th Floor, Ramakrishna Nagar, New Siddhapudur, Coimbatore, Tamil Nadu, Pin : 641 044</li>
              <li><MdMailOutline /> <a href='mailto:contact@bwefinserv.com' target='_blank' rel="noreferrer">contact@bwefinserv.com</a></li>
              <li><MdOutlinePhone /> <a href='tel:6383830073' target='_blank' rel="noreferrer">63838 30073</a></li>
            </ul>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button onClick={() => setOpenPrivacyPolicy(false)} className="btn-fill model-btn">Close</button>
      </Modal.Footer>
    </Modal>
  );
};

export default PrivacyPolicyModel;
